import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.mobilePhone && _setup.isLpuWorking
    ? _c(
        VBtn,
        {
          staticClass: "px-4",
          attrs: {
            color: "primary",
            "data-qa": "appointment-button-lpu-call",
            "data-google-goal": "appointment_button_lpu_call",
            elevation: "0",
            block: _setup.isMobile,
            href: `tel:${_setup.mobilePhone}`,
          },
          on: {
            click: function ($event) {
              return _setup.YaGoals.send({ name: "appointment-call__button" })
            },
          },
        },
        [
          _c("div", {
            staticClass: "ui-icon-phone-none ui-kit-bg-gray-0 mr-2",
          }),
          _vm._v(" "),
          _c("span", { staticClass: "button--text" }, [
            _vm._v(
              "\n    " +
                _vm._s(
                  _setup.t("Позвонить в клинику", { ns: _setup.language })
                ) +
                "\n  "
            ),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }